import styled, {css, keyframes} from "styled-components"
import {defaultThemeColors, mediaSizes} from "ui/theme"


export const ClassCardSkeleton = ({className}) => {
    return (
        <Container
            className={className}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <ImageContainer>
                <Svg aria-hidden="true"
                     xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                    <path
                        d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                </Svg>
            </ImageContainer>

            <TextContainer>
                <PlaceholderText/>
                <PlaceholderText width={65}/>
                <PlaceholderText/>
                <SeeMoreLine/>
            </TextContainer>
        </Container>
    );
};

const shimmer = keyframes`
    from {
        background-position: -1000px 0;
    }
    to {
        background-position: 1000px 0;
    }
`;
const fade = keyframes`
    0% {
        opacity: 0.5;
    }
    50% {
        opacity: 0.8;
    }
    100% {
        opacity: 0.5;
    }
`;

const shimmerEffect = css`
    animation: ${shimmer} 3s infinite linear;
    background: linear-gradient(to right, #e6e6e6 5%, #cccccc 25%, #e6e6e6 35%);
    background-size: 1000px 100%;
`;

const Container = styled.div`
    display: grid;
    gap: 13px;
    height: fit-content;
`;
const ImageContainer = styled.div`
    width: 100%;
    height: 250px;
    border-radius: 10px;
    background: ${defaultThemeColors.inputBgNeutral};
    color: ${defaultThemeColors.borderNeutral};
    display: grid;
    place-items: center;
    @media (width >= ${mediaSizes.md}) {
        height: 300px;
    }
    @media (width >= ${mediaSizes.lg}) {
        height: 350px;
    }


    ${shimmerEffect}
`;
const Svg = styled.svg`
    height: 3rem;
    width: 3rem;
`;

const TextContainer = styled.div`
    display: grid;
    gap: 5px;
`;
const PlaceholderText = styled.div`
    width: ${({width}) => (width ? width + "%" : "85%")};
    height: 13px;
    border-radius: 5px;
    background: ${defaultThemeColors.inputBgNeutral};
    ${shimmerEffect}
`;
const SeeMoreLine = styled.div`
    width: 40%;
    height: 13px;
    border-radius: 5px;
    ${shimmerEffect}
`;
